import { makeStyles } from '@material-ui/core/styles'

const forgotPasswordStyles = makeStyles(theme => ({
  ForgotPasswordDiv: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 114px)',
  },
  ForgotPasswordBox: {
    maxWidth: '400px',
    background: '#FFF',
    boxShadow: '0px 2px 10px #3F434714'
  },
  ForgotPasswordTextBox: {
    fontWeight: 'bold',
    fontSize: '2.375em',
    padding: '0 40px',
    textAlign: 'left',
    color: '#335977'
  },
  flexSpaceBtw:
  {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px'
  },
  container: {
    padding: '20px 40px',
    textAlign: 'center',
    fontSize: '0.875em'
  },
}))

export { forgotPasswordStyles }